import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';
var AutoPlanService = /** @class */ (function () {
    function AutoPlanService(httpClient) {
        this.httpClient = httpClient;
    }
    AutoPlanService.prototype.getPlanesByDocument = function (documentType, documentNumber) {
        var _urlParams = "documentType=" + documentType + "&documentNumber=" + documentNumber;
        return this.httpClient.get(environment.server.api.portalpas + '/Policy/plans?' + _urlParams).pipe(map(mapResponseWithData));
    };
    return AutoPlanService;
}());
export { AutoPlanService };
